import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type CountersInitialState = {
  escalated: number;
  manualUnread: number;
  archived: number;
  total: number;
  loading: boolean;
}

interface CountersState {
  escalated: number;
  manualUnread: number;
  archived: number;
  total: number;
  loading: boolean;
  setCounters: (payload: any) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
};

const countersInitialState: CountersInitialState = {
  escalated: 0,
  manualUnread: 0,
  archived: 0,
  total: 0,
  loading: true,
};

const useCountersStore = create(
  devtools<CountersState>(
    (set) => ({
      ...countersInitialState,
      setCounters: (payload) => {
        return set((state) => {
          const newEscalated = payload.escalated ?? state.escalated;
          const newManualUnread = payload.manualUnread ?? state.manualUnread;
          const newArchived = payload.archived ?? state.archived;

          return {
            ...state,
            escalated: newEscalated,
            manualUnread: newManualUnread,
            archived: newArchived,
            total: newEscalated + newManualUnread,
            loading: false,
          }
        });
      },
      setLoading: (loading) => set({ loading }),
      reset: () => set({ ...countersInitialState })
    }),
    { name: "useCountersStore" }
  ),
);

export default useCountersStore;

